"use client";
import { motion } from "framer-motion";
import { Home, ArrowLeft, Ghost } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom"; // If Next.js, use next/link

export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-slate-900 via-slate-800 to-black text-white px-6">
      
      {/* Floating background blobs */}
      <motion.div
        className="absolute -top-40 -left-40 w-[30rem] h-[30rem] bg-blue-500/10 blur-3xl rounded-full"
        animate={{ y: [0, 20, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute bottom-0 -right-40 w-[26rem] h-[26rem] bg-purple-500/10 blur-3xl rounded-full"
        animate={{ y: [0, -20, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative text-center max-w-xl">
        
        {/* Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 200, damping: 15 }}
          className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-white/10 mb-8"
        >
          <Ghost size={36} />
        </motion.div>

        {/* 404 */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-6xl sm:text-7xl font-extrabold tracking-tight bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent"
        >
          404
        </motion.h1>

        {/* Headline */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-2xl sm:text-3xl font-semibold mt-4"
        >
          {t("notfound.title")}
        </motion.h2>

        {/* Witty text */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mt-4 text-slate-400"
        >
          {t("notfound.description")}
        </motion.p>

        {/* Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="mt-10 flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2
                       px-6 py-3 rounded-full font-semibold
                       bg-white text-slate-900
                       hover:bg-slate-200 transition-colors"
          >
            <Home size={18} />
            {t("notfound.home_button")}
          </Link>

          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2
                       px-6 py-3 rounded-full font-semibold
                       border border-white/20
                       hover:bg-white hover:text-slate-900
                       transition-colors"
          >
            <ArrowLeft size={18} />
            {t("notfound.back_button")}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
